export const SPECPOINT_LEARN_LINK: string = 'https://learning.deltek.com/category/specpoint_learn_videos_courses_specpoint'